<template>
  <dom-template :company="company">
    <div slot="banner" class="company-banner" v-if="company.banner_url">
      <editable-image v-bind="$data" attribute="banner" width="4000" height="1400" recommendations="Recommended dimensions: 2560 × 900"></editable-image>
    </div>
    <div slot="banner" class="company-banner" v-if="!company.banner_url">
      <editable-image v-bind="$data" :kitten="true" attribute="banner" width="4000" height="1400" recommendations="Recommended dimensions: 2560 × 900"></editable-image>
    </div>

    <template slot="sidebar">
      <div class="company-name">
        <div class="company-logo" v-if="company.logo_url || editable">
          <editable-image v-bind="$data" attribute="logo" width="380" height="380" :removable="false" recommendations="Recommended dimensions: 380 x 380"></editable-image>
        </div>

        <company-name :id="company.slug" :value="company.name" :editable="editable"></company-name>

        <p class="company-location" v-if="company.locations.length > 0 && !company.remote">{{ company.locations[0].address }}</p>

        <p class="company-location" v-if="company.remote">The Internet</p>

        <company-motto :id="company.slug" :value="company.motto" :editable="editable" v-if="this.company.motto || this.admin"></company-motto>
      </div>

      <company-details :company="company" :is-form="form" :editable="editable"></company-details>
    </template>

    <company-mission-statement slot="mission-statement" :id="company.slug" :value="company.mission_statement" :editable="editable"></company-mission-statement>

    <div slot="gif" class="company-gif" v-if="company.gif_url || form">
      <editable-image v-bind="$data" attribute="gif" width="400" height="400" style="height:400px;" :resizable="true"></editable-image>
    </div>

    <template slot="jobs">
      <company-jobs :company="company" :editable="editable"></company-jobs>
    </template>

    <template slot="facts">
      <company-facts v-bind="{company, breakfastFoods, editable}" />
    </template>

    <template slot="like">
      <company-like :company="company"></company-like>
    </template>

  </dom-template>
</template>

<script>
  import CompanyDetails from './details'
  import CompanyMissionStatement from './mission-statement'
  import CompanyMotto from './motto'
  import CompanyName from './name'
  import CompanyFacts from './facts'
  import CompanyLike from './like'
  import CompanyJobs from './jobs'

  import DomTemplate from './dom-template'
  import EditableImage from '../components/editable-image'

  import CompanyUsers from './mixins/users'
  
  import {initYoutubeIframeAPI} from '../lib/youtube-iframes'

  export default {
    props: {
      company: {
        type: Object,
        required: true
      },
      breakfastFoods: {
        type: Array,
        required: true
      },
      admin: {
        type: Boolean,
        default: false
      },
      stub: {
        type: Boolean,
        default: true
      },
      form: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {
        resource: {
          company: this.company
        },
        url: '/companies/' + this.company.slug,
        editable: !!this.admin,
        likeLoading: false,
        liked: this.company.liked,
      }
    },
    mounted () {
      initYoutubeIframeAPI();
    },
    mixins: [CompanyUsers],
    components: {
      DomTemplate,
      EditableImage,
      CompanyDetails,
      CompanyMissionStatement,
      CompanyMotto,
      CompanyName,
      CompanyFacts,
      CompanyLike,
      CompanyJobs
    },
  }
</script>

<style scoped lang="scss">
  .company-banner {
    height: 0;
    margin-top: -1px;
    padding-top: 35.15625%; // 1280 x 450
    position: relative;

    .image-field {
      position: absolute;
      top: 0;
    }
  }

  .company-logo {
    height: 256px;
    margin-bottom: $gutter / 2;

    @include max-width($bp_left_sidebar_stacked) {
      float: left;
      margin-right: 20px;
      width: 150px;
      height: 150px;
    }
  }

  .company-gif {
    margin-bottom: $gutter / 2;
    width: 100%;
    max-width: 400px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// app/javascript/company/profile.vue?2c90c82c